import { render, staticRenderFns } from "./EditPersonTabContact.vue?vue&type=template&id=4258836a&scoped=true&"
import script from "./EditPersonTabContact.vue?vue&type=script&lang=js&"
export * from "./EditPersonTabContact.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonTabContact.vue?vue&type=style&index=0&id=4258836a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4258836a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
